import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import NotaEditor from "./NotaEditor";

/** Una nota flotante de cristal con franja de color: se arrastra por la cabecera, se agranda desde la esquina, se achica a la barra de abajo. */
function Flotante({ f, onMover, onFrente, onMin, onCerrar, onAparte, onTitulo }) {
  const drag = useRef(null);
  useEffect(() => {
    const mover = (e) => { if (!drag.current) return; onMover(f.id, Math.max(0, e.clientX - drag.current.dx), Math.max(0, e.clientY - drag.current.dy)); };
    const soltar = () => { drag.current = null; };
    window.addEventListener("pointermove", mover); window.addEventListener("pointerup", soltar);
    return () => { window.removeEventListener("pointermove", mover); window.removeEventListener("pointerup", soltar); };
  }, [f.id, onMover]);
  return (
    <div className="nt-fn" style={{ "--c": f.color, left: f.x, top: f.y, width: f.w, height: f.h, zIndex: 9000 + f.z, display: f.min ? "none" : "flex" }}
      data-testid="nt-flotante" onPointerDown={() => onFrente(f.id)}>
      <div className="nt-fh" data-testid="nt-flotante-cabecera" onPointerDown={(e) => { if (e.target.closest("button")) return; drag.current = { dx: e.clientX - f.x, dy: e.clientY - f.y }; }}>
        <span className="nt-dt" /><b className="nt-fh-t">{f.titulo || "Nota"}</b><span className="nt-sp" />
        <button type="button" className="nt-ib" aria-label="Achicar a la barra" data-testid="nt-flotante-min" onClick={() => onMin(f.id)}>—</button>
        <button type="button" className="nt-ib" data-testid="nt-flotante-aparte" onClick={() => onAparte(f.id)}>⧉ Pantalla aparte</button>
        <button type="button" className="nt-ib" aria-label="Cerrar" data-testid="nt-flotante-cerrar" onClick={() => onCerrar(f.id)}>✕</button>
      </div>
      <div className="nt-fb"><NotaEditor noteId={f.id} compacto onTitulo={(t, c) => onTitulo(f.id, t, c)} onBorrada={() => onCerrar(f.id)} /></div>
    </div>
  );
}

/** Capa global (sobre cualquier módulo): las notas flotantes y la barra de abajo con todas las abiertas. */
export default function NotasFlotantes({ flotantes, onMover, onFrente, onMin, onCerrar, onAparte, onTitulo, onNueva, onTodas }) {
  if (!flotantes.length) return null;
  return createPortal(
    <div className="nt">
      {flotantes.map((f) => <Flotante key={f.id} f={f} onMover={onMover} onFrente={onFrente} onMin={onMin} onCerrar={onCerrar} onAparte={onAparte} onTitulo={onTitulo} />)}
      <div className="nt-dk" data-testid="nt-dock">
        <button type="button" className="nt-chip plus" data-testid="nt-dock-nueva" onClick={onNueva}>＋ Nueva nota</button>
        {flotantes.map((f) => (
          <button type="button" key={f.id} className={`nt-chip${f.min ? "" : " on"}`} data-testid="nt-dock-nota" onClick={() => (f.min ? onMin(f.id) : onFrente(f.id))}>
            <i style={{ background: f.color }} />{f.titulo || "Nota"}
          </button>
        ))}
        <button type="button" className="nt-chip" data-testid="nt-dock-todas" onClick={onTodas}>⌕ Todas</button>
      </div>
    </div>,
    document.body,
  );
}
